// Espone le variabili d'ambiente di Vite come variabili globali per compatibilità
if (typeof window !== 'undefined') {
  (window as any).__VITE_CONFIG__ = {
    VITE_API_URL: import.meta.env.VITE_API_URL,
    VITE_NODE_ENV: import.meta.env.VITE_NODE_ENV,
    VITE_OPENAI_API_KEY: import.meta.env.VITE_OPENAI_API_KEY,
    VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  };
}
